<template>
	<q-page padding>
		<div class="row justify-center q-mt-xl desktop-hide" v-if="!showMaintenance">
			<div class="col-12">
				<q-card :style="backgroundColor">
					<q-card-title class="text-center">
						<img class="logo-login" :src="login_logo" />
					</q-card-title>

					<q-card-separator />

					<q-card-main>
						<q-btn color="primary" class="full-width q-mb-lg" icon="fal fa-sign-in"
							:label="$t('sign_in_with_user_email_and_password')"
							@click="webinar_custom_login = !webinar_custom_login" v-if="webinar_custom_login" />

						<q-input lower-case v-if="!webinar_custom_login" v-model="username" :dark="lightOrDark"
							:float-label="$t(this.login_accept_document ? 'user' : 'login')"
							@keyup.enter.native="login()" :error="$v.username.$error" @input="$v.username.$touch" />

						<q-input v-if="!webinar_custom_login" v-model="password" :dark="lightOrDark" type="password"
							:float-label="$t('password')" @keyup.enter.native="login()" :error="$v.password.$error"
							@input="$v.password.$touch" />

						<q-btn :color="colorSignIn" class="full-width q-my-md" icon="fal fa-sign-in"
							:label="$t('sign_in')" @click="login()" v-if="showRegularLogin && !webinar_custom_login" />

						<q-btn color="primary" class="full-width q-my-lg" icon="fal fa-sign-in" :label="$t('sign_in')"
							@click="loginPopTrade()" v-if="showPopTradeOauth" />

						<q-btn color="primary" class="full-width q-my-lg" icon="fal fa-sign-in" :label="$t('sign_in')"
							@click="loginSevenTrade()" v-if="showSevenTradeOauth" />

						<div class="text-center" v-if="!webinar_custom_login">
							<router-link :style="fontColor" class="text-secondary" :to="{
			name: 'recover-password',
			params: {
				email: username && username.includes('@') ? username : '',
				document: '',
			},
		}">{{ $t('forgot_password') }}</router-link>
						</div>
					</q-card-main>

					<q-card-separator v-if="(showRegister && !webinar_custom_login) ||
			showPopTradeOauth ||
			showSevenTradeOauth
			" />

					<q-card-actions v-if="(showRegister && !webinar_custom_login) ||
			showPopTradeOauth ||
			showSevenTradeOauth
			">
						<q-btn color="secondary" class="full-width q-my-sm" :label="$t('sign_up')"
							v-if="showRegister && !webinar_custom_login" @click="$router.push({ name: 'register' })" />

						<q-btn color="secondary" class="full-width q-my-sm" :label="$t('first_access')"
							v-if="showPopTradeOauth" @click="$router.push({ name: 'register-pop-trade' })" />

						<q-btn color="secondary" class="full-width q-my-sm" :label="$t('first_access')"
							v-if="showSevenTradeOauth" @click="$router.push({ name: 'register-seven-trade' })" />
					</q-card-actions>

					<q-card-separator v-if="login_recaptcha" />

					<q-card-main v-if="login_recaptcha">
						<div class="text-faded text-center q-mb-sm">
							{{ $t('this_site_is_protected_by_googles_recaptcha') }}.
							{{ $t('do_apply') }}
							<a class="text-secondary" href="https://policies.google.com/privacy" target="_blank">{{
			$t('privacy_policy') }}</a>
							{{ $t('and') }}
							<a class="text-secondary" href="https://policies.google.com/terms" target="_blank">{{
			$t('terms_of_service') }}</a>
							.
						</div>
					</q-card-main>
				</q-card>
			</div>
		</div>

		<div class="row justify-center q-mt-xl desktop-hide" v-if="showMaintenance">
			<div class="col-12">
				<q-card :style="backgroundColor">
					<q-card-title class="text-center">
						<img class="logo-login" :src="login_logo" />
					</q-card-title>

					<q-card-separator />

					<q-card-main class="q-title q-py-lg text-weight-regular">
						{{ $t('maitenance_mode_text') }}
					</q-card-main>
				</q-card>
			</div>
		</div>

		<q-card class="round-borders card-login mobile-hide fixed-center">
			<div class="row">
				<div class="col-6 text-center q-px-xl" v-if="!showMaintenance" :style="backgroundColor">
					<img class="q-pt-md logo-login" :src="login_logo" />

					<q-btn color="primary" class="full-width" icon="fal fa-sign-in"
						:label="$t('sign_in_with_user_email_and_password')"
						@click="webinar_custom_login = !webinar_custom_login" v-if="webinar_custom_login" />

					<q-input v-if="!webinar_custom_login" v-model="username" :dark="lightOrDark"
						:float-label="$t(this.login_accept_document ? 'user' : 'login')" @keyup.enter.native="login()"
						:error="$v.username.$error" @input="$v.username.$touch" />

					<q-input v-if="!webinar_custom_login" v-model="password" :dark="lightOrDark" type="password"
						:float-label="$t('password')" @keyup.enter.native="login()" :error="$v.password.$error"
						@input="$v.password.$touch" />

					<q-btn :color="colorSignIn" class="full-width q-my-lg" icon="fal fa-sign-in" :label="$t('sign_in')"
						@click="login()" v-if="showRegularLogin && !webinar_custom_login" />

					<q-btn color="primary" class="full-width q-my-lg" icon="fal fa-sign-in" :label="$t('sign_in')"
						@click="loginPopTrade()" v-if="showPopTradeOauth" />

					<q-btn color="primary" class="full-width q-my-lg" icon="fal fa-sign-in" :label="$t('sign_in')"
						@click="loginSevenTrade()" v-if="showSevenTradeOauth" />

					<router-link v-if="!showPopTradeOauth && !webinar_custom_login" :to="{
			name: getRecoverPasswordRoute,
			params: {
				email: username && username.includes('@') ? username : '',
				document: '',
			},
		}" :style="fontColor">
						{{ $t('forgot_password') }}
					</router-link>

					<hr class="q-hr q-my-mg" v-if="(showRegister && !webinar_custom_login) ||
			showPopTradeOauth ||
			showSevenTradeOauth
			" />

					<q-btn color="secondary" class="full-width q-my-sm" :label="$t('sign_up')"
						v-if="showRegister && !webinar_custom_login" @click="$router.push({ name: 'register' })" />

					<q-btn color="secondary" class="full-width q-my-sm" :label="$t('first_access')"
						v-if="showPopTradeOauth" @click="$router.push({ name: 'register-pop-trade' })" />

					<q-btn color="secondary" class="full-width q-my-sm" :label="$t('first_access')"
						v-if="showSevenTradeOauth" @click="$router.push({ name: 'register-seven-trade' })" />

					<hr class="q-hr q-my-mg" v-if="login_recaptcha" />

					<div class="text-faded text-center q-body-1 q-mt-md" v-if="login_recaptcha">
						{{ $t('this_site_is_protected_by_googles_recaptcha') }}.
						{{ $t('do_apply') }}
						<a class="text-secondary" href="https://policies.google.com/privacy" target="_blank">{{
			$t('privacy_policy') }}</a>
						{{ $t('and') }}
						<a class="text-secondary" href="https://policies.google.com/terms" target="_blank">{{
			$t('terms_of_service') }}</a>
						.
					</div>
				</div>

				<div class="col-6 text-center q-px-xl" v-if="showMaintenance" :style="backgroundColor">
					<img class="q-pt-xl logo-login" :src="login_logo" />

					<p class="q-headline q-mt-xl">
						{{ $t('maitenance_mode_text') }}
					</p>
				</div>

				<div class="col-6 login-image text-center text-white"
					:style="{ backgroundImage: 'url(' + login_background + ')' }">
					<div class="login-text">
						<h2>{{ login_text_header }}</h2>
						<p>{{ login_text }}</p>
					</div>
				</div>
			</div>
		</q-card>

		<vue-recaptcha ref="invisibleRecaptcha" @verify="checkVerify" size="invisible" :sitekey="recaptchaCode"
			:loadRecaptchaScript="true" badge="inline">
		</vue-recaptcha>

		<q-dialog v-model="show_error" @ok="hideError()" :cancel="false">
			<span slot="title">{{ $t('login_error') }}</span>

			<span slot="message">{{
			custom_error_message ? custom_error_message : $t('username_password_incorrect')
				}}</span>
		</q-dialog>
	</q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'
import { uid, debounce } from 'quasar'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'login'] },

	data() {
		return {
			username: '',
			password: '',
			show_error: false,
			code: null,
			redirected_page: '',
			show_custom_error_message: false,
			custom_error_message: '',
			webinar_custom_login: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			login_text_header: 'params/login_text_header',
			login_text: 'params/login_text',
			login_background: 'params/login_background',
			login_logo: 'params/login_logo',
			login_oauth2: 'params/login_oauth2',
			login_recaptcha: 'params/login_recaptcha',
			login_under_maintenance: 'params/login_under_maintenance',
			login_accept_document: 'params/login_accept_document',
			clients: 'params/clients',
			attempts: 'params/attempts',
			user_pre_register: 'params/login_user_pre_register',
			user_register: 'params/login_user_register',
			register_store: 'params/register',
			login_font_color: 'params/login_font_color',
			login_background_color: 'params/login_background_color',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
				},
			})
		},

		getAuthHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		getRecoverPasswordRoute() {
			if (this.showPopTradeOauth) return 'recover-password-pop-trade'
			else if (this.showSevenTradeOauth) return 'recover-password-seven-trade'
			else return 'recover-password'
		},

		showRegister() {
			if (
				this.user_pre_register ||
				(this.user_register && !this.showPopTradeOauth && !this.showSevenTradeOauth)
			)
				return true
			else return false
		},

		showRegularLogin() {
			if (this.showPopTradeOauth || this.showSevenTradeOauth) return false
			else return true
		},

		showPopTradeOauth() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => {
					return obj.slug === 'academiapoptrade'
				})
				if (obj) return obj.is_active
			}
			return false
		},

		showSevenTradeOauth() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => {
					return obj.slug === 'academiaseventrade'
				})
				if (obj) return obj.is_active
			}
			return false
		},

		recaptchaCode() {
			return process.env.GOOGLE_RECAPCHA_KEY
		},

		showMaintenance() {
			return this.login_under_maintenance && this.$route.name != 'maintenance-login'
				? this.login_under_maintenance
				: false
		},

		colorSignIn() {
			return 'secondary'
		},

		backgroundColor() {
			if (this.$q.platform.is.mobile) {
				if (this.login_background_color)
					return `background-color:${this.login_background_color};`
				else return `background-color:#FFFFFF;`
			} else {
				if (this.login_background_color)
					return `background-color:${this.login_background_color
						}; border-radius: 20px 0px 0px 20px !important;`
				else return `background-color:#FFFFFF; border-radius: 20px !important;`
			}
		},

		fontColor() {
			if (this.login_font_color) {
				return `color:${this.login_font_color} !important;`
			} else {
				return `color:#000000 !important;`
			}
		},

		lightOrDark() {
			if (this.login_background_color) {
				let color = this.login_background_color
				let r, g, b, hsp

				if (color.match(/^rgb/)) {
					color = color.match(
						/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
					)

					r = color[1]
					g = color[2]
					b = color[3]
				} else {
					color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

					r = color >> 16
					g = (color >> 8) & 255
					b = color & 255
				}

				hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

				if (hsp > 127.5) return false
				else return true
			} else return true
		},
	},

	methods: {
		login() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				if (this.login_recaptcha && this.attempts >= 3) {
					this.$q.loading.hide()
					this.$refs.invisibleRecaptcha.execute()
				} else {
					if (process.env.PROJECT_FOLDER === 'academiapoptrade') this.loginPopTrade()
					else if (process.env.PROJECT_FOLDER === 'academiaseventrade')
						this.loginSevenTrade()
					else this.continueLogin()
				}
			}
		},

		checkVerify(response) {
			this.continueLogin(response)
		},

		continueLogin(google_token) {
			this.$q.loading.show()

			let data = {
				grant_type: 'password',
				username: this.username,
				password: this.password,
			}

			if (google_token) data.google_token = google_token

			if (!this.login_accept_document) {
				this.$axios
					.post('/o/token/', this.$qs.stringify(data), this.getHeader)
					.then((response) => {
						this.$store.dispatch('params/SET_ATTEMPTS', [0])
						this.setUserData(response)
					})
					.catch((e) => {
						this.$q.loading.hide()
						this.show_error = true

						if (e.response) {
							if (e.response.data.qty_login_attempts) {
								this.$store.dispatch('params/SET_ATTEMPTS', [
									e.response.data.qty_login_attempts,
								])
							}
						}

						if (this.login_recaptcha && this.attempts >= 3)
							this.$refs.invisibleRecaptcha.reset()

						console.log(e)
					})
			} else {
				this.$axios
					.post(
						'/etraining_login/alternative_login/',
						this.$qs.stringify(data),
						this.getHeader
					)
					.then((response) => {
						this.$store.dispatch('params/SET_ATTEMPTS', [0])
						this.setUserData(response)
					})
					.catch((e) => {
						this.$q.loading.hide()
						this.show_error = true

						if (e.response) {
							if (e.response.data.qty_login_attempts) {
								this.$store.dispatch('params/SET_ATTEMPTS', [
									e.response.data.qty_login_attempts,
								])
							}
						}

						if (this.login_recaptcha && this.attempts >= 3)
							this.$refs.invisibleRecaptcha.reset()

						console.log(e)
					})
			}
		},

		loginPopTrade() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => {
					return obj.slug === 'academiapoptrade'
				})
				if (obj) {
					this.$v.$touch()

					if (!this.$v.$error) {
						this.$q.loading.show()

						let data = {
							grant_type: 'password',
							username: this.username,
							password: this.password,
						}

						this.$axios
							.post(obj.oauth_url, this.$qs.stringify(data), this.getHeader)
							.then((response) => {
								this.setUserData(response)
							})
							.catch((e) => {
								this.$q.loading.hide()

								if (e.response.data.messages) {
									this.show_custom_error_message = true
									this.custom_error_message = `${e.response.data.owner} - ${e.response.data.messages[0]
										}`
								} else if (e.response.data.message) {
									this.show_custom_error_message = true
									this.custom_error_message = e.response.data.message
								}

								this.show_error = true
								console.log(e)
							})
					}
				}
			}
		},

		loginSevenTrade() {
			if (this.login_oauth2) {
				let obj = this.login_oauth2.find((obj) => {
					return obj.slug === 'academiaseventrade'
				})
				if (obj) {
					this.$v.$touch()

					if (!this.$v.$error) {
						this.$q.loading.show()

						let data = {
							grant_type: 'password',
							username: this.username,
							password: this.password,
						}

						this.$axios
							.post(obj.oauth_url, this.$qs.stringify(data), this.getHeader)
							.then((response) => {
								this.setUserData(response)
							})
							.catch((e) => {
								this.$q.loading.hide()
								this.show_error = true
								console.log(e)
							})
					}
				}
			}
		},

		setUserData(response) {
			this.$store.dispatch('common/SET_ACCESS_TOKEN', [
				response.data.access_token,
				response.data.refresh_token,
				response.data.user_firebase_token,
			])
			if (response.data.user_firebase_token) {
				firebase
					.auth()
					.signInWithCustomToken(response.data.user_firebase_token)
					.then(() => {
						if (this.$q.platform.is.cordova) {
							this.setUserDeviceToken()
						} else {
							this.getWelcomeBanner()
						}
					})
					.catch((e) => {
						console.log(e)
					})
			} else {
				if (this.$q.platform.is.cordova) {
					this.setUserDeviceToken()
				} else {
					this.getWelcomeBanner()
				}
			}
		},

		setUserDeviceToken() {
			// window.plugins.OneSignal.getIds((ids) => {
			//     let fd = new FormData()
			//     fd.append('token', ids.userId)
			//     fd.append('device_type', this.$q.platform.is.android ? 'android' : 'ios')

			//     this.$axios.post('/etraining_login/set_user_device_token/', fd, this.getAuthHeader)
			//     .then(response => {
			this.getWelcomeBanner()
			//     })
			//     .catch(e => {
			//         this.getWelcomeBanner()
			//         console.log(e)
			//     })
			// })
		},

		getWelcomeBanner() {
			this.$axios
				.get('/etraining_banners_welcome/banners_welcome/', this.getAuthHeader)
				.then((response) => {
					this.$store.dispatch('welcome_banner/SET_WELCOME_BANNER', [response.data])
					this.getUserData()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getUserData() {
			this.$axios
				.get('/accounts/read_user_data/', this.getAuthHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])

					if (
						this.register_store.default_password === this.password &&
						this.password !== ''
					)
						this.$store.dispatch('common/SET_USER_CHANGE_PASSWORD', [true])

					// Samsung academy
					if (this.redirected_page) {
						this.$router.replace({ name: this.redirected_page })
						return
					} else if (this.$route.name === 'redirect-control-pannel-v2') {
						this.$router.replace({ name: 'admin_overview' })
						return
					}

					this.$router.replace({ name: 'admin_overview' })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		hideError() {
			this.show_error = false
			this.custom_error_message = false
		},
		getCookie(name) {
			let matches = document.cookie.match(new RegExp(
				"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
			));
			return matches ? decodeURIComponent(matches[1]) : undefined;
		}
	},

	created() {
		if (!this.access_token) {
			this.$store.dispatch('common/SET_USER_DATA', [
				'',
				'',
				'',
				'',
				'',
				'',
				'',
				[],
				[],
				[],
				,
				false,
				'',
				[],
				false,
				'',
				[],
				[],
				[],
			])
		}

		if (this.$q.platform.is.mobile && !this.$q.platform.is.cordova) {
			if (this.$q.platform.is.android && process.env.APP_URL_GOOGLE) {
				this.$q.notify({
					message: this.$t('for_a_better_experience_install_the_app'),
					type: 'positive',
					icon: 'fab fa-android',
					timeout: 0,
					closeBtn: false,
					actions: [
						{
							label: this.$t('install'),
							noDismiss: false,
							handler: () => {
								window.open(process.env.APP_URL_GOOGLE)
							},
						},
						{
							label: this.$t('close'),
							noDismiss: false,
						},
					],
				})
			} else if (this.$q.platform.is.apple && process.env.APP_URL_APPLE) {
				this.$q.notify({
					message: this.$t('for_a_better_experience_install_the_app'),
					type: 'info',
					icon: 'fab fa-apple',
					timeout: 0,
					closeBtn: false,
					actions: [
						{
							label: this.$t('install'),
							noDismiss: false,
							handler: () => {
								if (this.$q.platform.is.cordova) {
									cordova.InAppBrowser.open(
										process.env.APP_URL_APPLE,
										'_system',
										'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no'
									)
								} else {
									window.open(process.env.APP_URL_APPLE)
								}
							},
						},
						{
							label: this.$t('close'),
							noDismiss: false,
						},
					],
				})
			}
		}

		window.handleOpenURL = (url) => {
			let u = new URL(url)
			let params = new URLSearchParams(u.search)

			//New password
			if (params.has('origin') && params.get('origin') == 'recover-password') {
				this.$router.push({
					name: 'set-new-password',
					params: {
						username: params.get('username'),
						uidb64: params.get('uidb64'),
						token: params.get('token'),
					},
				})
				return
			}

			//New user
			if (params.has('origin') && params.get('origin') == 'set-password') {
				this.$router.push({
					name: 'set-password',
					params: {
						username: params.get('username'),
						uidb64: params.get('uidb64'),
						token: params.get('token'),
					},
				})
				return
			}

			//New message
			if (params.has('origin') && params.get('origin') == 'message') {
				this.$router.push({
					name: 'home',
					params: {
						message_id: params.get('message_id'),
					},
				})
				return
			}

			//Login samsung webinar
			if (
				params.has('origin') ||
				(params.get('origin') === 'login-samsung' && !this.access_token)
			) {
				this.$q.loading.show()

				let response = {}

				response.data = {
					access_token: params.get('access_token'),
					expires_in: params.get('expires_in'),
					refresh_token: params.get('refresh_token'),
					result: params.get('result'),
					scope: params.get('scope'),
					token_type: params.get('token_type'),
					user_firebase_token: params.get('user_firebase_token'),
					user_id: params.get('user_id'),
				}

				this.setUserData(response)
			}
		}

		if (this.$route.name === 'login-samsung') {
			this.$q.loading.show()

			let response = {}

			response.data = {
				access_token: this.$route.query.access_token,
				expires_in: this.$route.query.expires_in,
				refresh_token: this.$route.query.refresh_token,
				result: this.$route.query.result,
				scope: this.$route.query.scope,
				token_type: this.$route.query.token_type,
				user_firebase_token: this.$route.query.user_firebase_token,
				user_id: this.$route.query.user_id,
			}
			this.redirected_page = this.$route.query.redirected_page
			this.setUserData(response)
		}

		if (this.$route.name === 'redirect-control-pannel-v2') {
			const at_token = this.getCookie('at-v2')
			if (at_token) {
				this.$q.loading.show()


				let headers = {
					headers: {
						'content-type': 'application/json',
						authorization: 'Bearer ' + at_token,
						'X-PNSC': at_token
					},
				}

				this.$axios
					.post('/etraining_login/tswap/', {}, headers)
					.then((response) => {
						this.setUserData(response)
					})
					.catch((e) => {
						console.log(e)
					})
			}
		}
	},

	watch: {
		login_oauth2: function () { },
	},

	validations() {
		return {
			username: { required },
			password: { required },
		}
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'

a
    text-decoration none

.login-image
    background-repeat no-repeat
    background-position right
    background-size cover
    height 70vh
    position relative
    border-radius 0 20px 20px 0 !important

.login-text
    position absolute
    top 0
    bottom 0
    left 0
    right 0
    width 80%
    height 40%
    margin auto

h2
    line-height 0

.round-borders
    border-radius 23px 0px 0px 23px !important

.card-login
    margin-top -50px
    width 90%

.unstyled-button
    width 100%
    text-align center
    cursor pointer
    .q-icon
        vertical-align baseline
</style>
